// src/hooks/useFormValidator.js

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
const phoneRegex = /^\d{10}$/;

const validateByType = (type, form) => {
  const errors = {};
  switch (type) {
    case 'support':
      if (!form.subject) {
        errors.subject = 'Subject is a required.';
      }
      if (!form.description) {
        errors.description = 'Message is a required. ';
      }
      break;

    case 'discussionBox':
      if (!form.title) {
        errors.title = 'Topic is required.';
      }

      if (!form.content) {
        errors.content = 'Description is required.';
      }
      break;

    case 'contactUs':
      if (!form.email) {
        errors.email = 'Email is required.';
      } else if (!emailRegex.test(form.email)) {
        errors.email = 'Invalid email address.';
      }

      if (!form.name) {
        errors.name = 'Name is required.';
      } else if (!/^[A-Za-z\s]+$/.test(form.name)) {
        errors.name = 'Only letters allowed in first name.';
      } else if (form.name.length <= 2 || form.name.length >= 20) {
        errors.name = 'First name must be between 2 and 20 characters.';
      }
      if (!form.subject) {
        errors.subject = 'Subject is a required.';
      }
      if (!form.message) {
        errors.message = 'Message is a required. ';
      }
      break;

    case 'login':
      if (!form.email) {
        errors.email = 'Email is required.';
      } else if (!emailRegex.test(form.email)) {
        errors.email = 'Invalid email address.';
      }

      if (!form.password) {
        errors.password = 'Password is required.';
      }
      break;

    case 'unlockAccount':
      if (!form.email) {
        errors.email = 'Email is required.';
      } else if (!emailRegex.test(form.email)) {
        errors.email = 'Invalid email address.';
      }
      break;

    case 'register':
      if (!form.email) {
        errors.email = 'Email is required.';
      } else if (!emailRegex.test(form.email)) {
        errors.email = 'Invalid email address.';
      }

      if (!form.phone) {
        errors.phone = 'Phone is required.';
      } else if (!phoneRegex.test(form.phone)) {
        errors.phone = 'Phone must be exactly 10 digits (numbers only).';
      }

      if (!form.sector) {
        errors.sector = 'Category is required.';
      }

      if (!form.password) {
        errors.password = 'Password is required.';
      } else {
        if (form.password.length < 8) {
          errors.password = 'Password is too short.';
        } else if (!/[a-z]/.test(form.password)) {
          errors.password = 'Must include at least one lowercase letter.';
        } else if (!/[A-Z]/.test(form.password)) {
          errors.password = 'Must include at least one uppercase letter.';
        } else if (!/[0-9]/.test(form.password)) {
          errors.password = 'Must include at least one digit.';
        }
      }

      if (!form.password_confirmation) {
        errors.password_confirmation = 'Confirm password is required.';
      } else if (form.password !== form.password_confirmation) {
        errors.password_confirmation = 'Passwords does not match.';
      }
      break;

    case 'forgotPassword':
      if (!form.email) {
        errors.email = 'Email is required.';
      } else if (!emailRegex.test(form.email)) {
        errors.email = 'Invalid email address.';
      }
      break;

    case 'resetPassword':
      if (!form.password) {
        errors.password = 'Password is required.';
      } else {
        if (form.password.length < 8) {
          errors.password = 'Password is too short.';
        } else if (!/[a-z]/.test(form.password)) {
          errors.password = 'Must include at least one lowercase letter.';
        } else if (!/[A-Z]/.test(form.password)) {
          errors.password = 'Must include at least one uppercase letter.';
        } else if (!/[0-9]/.test(form.password)) {
          errors.password = 'Must include at least one digit.';
        }
      }

      if (!form.password_confirmation) {
        errors.password_confirmation = 'Confirm password is required.';
      } else if (form.password !== form.password_confirmation) {
        errors.password_confirmation = 'Passwords does not match.';
      }
      break;

     case 'profileUser':
      if (!form.email) {
        errors.email = 'Email is required.';
      } else if (!emailRegex.test(form.email)) {
        errors.email = 'Invalid email format.';
      }

      if (!form.first_name) {
        errors.first_name = 'First name is required.';
      } else if (!/^[A-Za-z\s]+$/.test(form.first_name)) {
        errors.first_name = 'Only letters and spaces are allowed in first name.';
      } else if (form.first_name.length <= 2 || form.first_name.length >= 20) {
        errors.first_name = 'First name must be between 2 and 20 characters.';
      }

      if (!form.last_name) {
        errors.last_name = 'Last name is required.';
      } else if (!/^[A-Za-z\s]+$/.test(form.last_name)) {
        errors.last_name = 'Only letters allowed in last name.';
      } else if (form.last_name.length <= 2 || form.last_name.length >= 20) {
        errors.last_name = 'Last name must be between 2 and 20 characters.';
      }

      if (!form.phone) {
        errors.phone = 'Phone is required.';
      } else if (!/^\d{10}$/.test(form.phone)) {
        errors.phone = 'Phone must be exactly 10 digits (numbers only).';
      }
      break;



    case 'profilePassword':
      if (!form.current_password) {
        errors.current_password = 'Current password is required.';
      }

      if (!form.password) {
        errors.password = 'New password is required.';
      } else {
        if (form.password.length < 8) {
          errors.password = 'Password must be at least 8 characters.';
        } else if (!/[a-z]/.test(form.password)) {
          errors.password = 'Include a lowercase letter.';
        } else if (!/[A-Z]/.test(form.password)) {
          errors.password = 'Include an uppercase letter.';
        } else if (!/[0-9]/.test(form.password)) {
          errors.password = 'Include at least one digit.';
        }
      }

      if (form.password !== form.password_confirm) {
        errors.password_confirm = 'Passwords does not match.';
      }
      break;

    default:
      break;
  }

  return errors;
};

export default validateByType;
